var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import styled from "styled-components";
import { colorFromTheme, safeElement } from "../../../utils";
import { Typography } from "../../../index";
import { Spinner } from "./Spinner";

var InnerContent = function InnerContent(props) {
  var children = props.children,
      paddingLeft = props.paddingLeft,
      paddingRight = props.paddingRight,
      textColor = props.textColor,
      compact = props.compact,
      loading = props.loading,
      restProps = _objectWithoutProperties(props, ["children", "paddingLeft", "paddingRight", "textColor", "compact", "loading"]);

  if (compact) {
    paddingLeft = 1.5;
    paddingRight = 1.5;
  }

  var ColorFromTheme = colorFromTheme(textColor);

  return React.createElement(
    WrapperStyled,
    _extends({
      $as: "span",
      textColor: ColorFromTheme,
      paddingLeft: typeof paddingLeft === "string" ? paddingLeft : paddingLeft + "rem",
      paddingRight: typeof paddingRight === "string" ? paddingRight : paddingRight + "rem"
    }, restProps),
    loading && React.createElement(Spinner, _extends({ color: ColorFromTheme }, props)),
    React.createElement(
      ChildrenWrapper,
      { $as: "span", loading: loading },
      React.createElement(
        Typography,
        {
          $as: "span",
          color: "textColor",
          size: 1,
          bold: true,
          style: { display: "flex", alignItem: "center" }
        },
        children
      )
    )
  );
};

export { InnerContent };
InnerContent.defaultProps = {
  paddingLeft: 2,
  paddingRight: 2,
  compact: false
};

var WrapperStyled = styled(safeElement()).withConfig({
  displayName: "InnerContent__WrapperStyled",
  componentId: "sc-99vf00-0"
})(["position:relative;display:block;pointer-events:none;height:100%;display:flex;justify-content:center;align-items:center;padding-left:", ";padding-right:", ";color:", ";"], function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.paddingRight;
}, function (props) {
  return props.textColor;
});

var ChildrenWrapper = styled(safeElement()).withConfig({
  displayName: "InnerContent__ChildrenWrapper",
  componentId: "sc-99vf00-1"
})(["display:flex;align-items:center;white-space:nowrap;transition:opacity 120ms linear,filter 120ms linear,transform 400ms ease-in-out;opacity:", ";filter:", ";transform:", ";"], function (props) {
  return props.loading ? 0 : 1;
}, function (props) {
  return props.loading ? "blur(3px)" : "blur(0px)";
}, function (props) {
  return props.loading ? "scale(0.9)" : "scale(1)";
});